/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import cn from 'classnames';
import { shape, string, bool } from 'prop-types';

import Spinner from 'react-spinkit';

import Paper from '@mui/material/Paper';

import s from './LoadingOverlay.css';

const LoadingOverlay = props => {
  const {
    className,
    style,
    iconStyle,
    iconColor,
    iconType,
    coverParent,
    noLayoutPadding,
    variant,
    noFadeIn,
    ...restProps
  } = props;

  return (
    <Paper
      classes={{
        root: cn(
          s.loadingOverlay,
          className,
          coverParent && s.coverParent,
          noLayoutPadding && s.noLayoutPadding,
          {
            [s.casefileVariant]: variant === 'casefile',
          },
        ),
      }}
      style={style}
      {...restProps}
    >
      <Spinner
        className={s.loadingIcon}
        style={iconStyle}
        name={iconType}
        color={iconColor}
        fadeIn={noFadeIn ? 'none' : 'half'}
      />
    </Paper>
  );
};

LoadingOverlay.propTypes = {
  className: string,
  style: shape({}),
  iconStyle: shape({}),
  iconColor: string,
  iconType: string,
  coverParent: bool,
  noLayoutPadding: bool,
  variant: string,
  noFadeIn: bool,
};

LoadingOverlay.defaultProps = {
  className: undefined,
  style: undefined,
  iconStyle: {},
  iconColor: '#bbb',
  iconType: 'line-scale',
  coverParent: false,
  noLayoutPadding: false,
  variant: 'default',
  noFadeIn: false,
};

export default LoadingOverlay;
